export default {
  elements: {},
  init() {
    // Check if the URL contains an anchor link
    if (window.location.hash) {
      // Get the anchor link from the URL
      var hash = window.location.hash;
      // Remove the '#' symbol from the anchor link
      hash = hash.substring(1);
      // Scroll to the anchor
      $("html, body").animate(
        {
          scrollTop: $("#" + hash).offset().top,
        },
        1000
      );
    }
    this.elements.parent = $(".explanatory-menu");
    if (this.elements.parent.length > 0) {
      //replace any outstanding court type placeholders
      $(".explanatory-menu a").each(function () {
        var link = $(this).attr("href");
        link = link.replace("%court-type%", "magistrates-court");
        $(this).attr("href", link);
      });

      //click events
      $(".explanatory-menu .page_item_has_children > a").on(
        "click",
        function (e) {
          e.preventDefault();

          $(this).parent().toggleClass("open");
          $(this).next(".children").toggleClass("active");
        }
      );

      $(".toggler").on("click", function (e) {
        e.preventDefault();

        $(this).siblings(".tree").toggleClass("active");
        var text = $(this).text();
        $(this).text(
          text == "Show all parts of this guide"
            ? "Hide all parts of this guide"
            : "Show all parts of this guide"
        );
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/components/explanatorymenu.js